var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        _vm._l(_vm.statistic, function (item) {
          return _c(
            "v-col",
            { key: item.title, attrs: { xs: "12", md: "12", lg: "6" } },
            [
              _c(
                "div",
                {
                  staticClass:
                    "pa-4 d-flex align-center has-border full-height",
                  staticStyle: { "background-color": "#f8f8f8" },
                },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-3", attrs: { color: "primary" } },
                    [_vm._v(_vm._s(item.image))]
                  ),
                  _c("div", [
                    _c("div", [_vm._v(_vm._s(item.title))]),
                    _c("div", { staticClass: "d-inline-flex align-end" }, [
                      _c("div", { staticClass: "text-h5 font-weight-medium" }, [
                        _vm._v(" " + _vm._s(item.number) + " "),
                      ]),
                      item.type === "income"
                        ? _c("div", { staticClass: "ml-1 caption" }, [
                            _vm._v(" VNĐ "),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ],
                1
              ),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }